import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
import { Formik } from "formik"; 
 
function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
}

// function titleToggleJS() {
//   var titleToggle = document.getElementById("contactHeaderTitleContainer");
//   titleToggle.classList.add("hiddenContactHeader");
//   // console.log(titleToggle);
// }

export class DemoFormLongC19 extends React.Component {

  state = { error: false, submitted: false };

  validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    company_size: Yup.string().required("Required"),
    email: Yup.string()
      .email("Must be a valid email")
      .required("Required")

    // .matches(/^((?!hotmail|yahoo|gmail|outlook|iCloud|aol).)*$/i, "Company Email Only")
  });

  checkboxToBoolean = (value) => {
    return (value && value.length > 0) ? true : false;
  }

  handleSubmit = (values) => {
    
    // console.log(values)
    // console.log(this.checkboxToBoolean(values.roster_access))
    
    axios
      .request({
        method: "POST",
        url: "https://api.charthop.com/contact",
        data: {
          ...values,
          roster_access: this.checkboxToBoolean(values.roster_access),
          headcount_access: this.checkboxToBoolean(values.headcount_access),
          source: 'c19form'
        }
      })
      .then(
        res => {
          this.setState({ submitted: true });
          this.btn.setAttribute("disabled", "disabled");
          this.btn.removeAttribute("disabled");
        },
        err => {
          this.setState({ error: true });
        }
      );
  };

  render() {
    if (this.state.submitted) {

      return (

        <div className="pt-callout pt-intent-primary pt-submission-success sectionSpacing pb-0">
          <img src={'/home/successfulFormSubmission.svg'} alt="The ChartHop logo" />
          <p>Thanks for requesting access to ChartHop!</p>
          <p>We'll be in touch with next steps.</p>
          <p>Stay healthy!</p>
          {/* {titleToggleJS()} */}
        </div>

      );
    }

    return (
      <Formik 
        initialValues={{ name: "", email: "", company_size: "", note: "" }}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={form => (

          <form
            className="demolongform"
            onSubmit={form.handleSubmit}
          >

            <div className={toFormGroupClass("name", form)}>
              <label className="pt-label" htmlFor="name">
                Full Name
              </label>
              <input
                id="name"
                type="text"
                className="pt-input"
                value={form.values.name}
                onChange={form.handleChange}
                placeholder="Full Name"
              />
              {form.touched.name && form.errors.name && (
                <div className="pt-form-helper-text">{form.errors.name}</div>
              )}
            </div>

            <div className={toFormGroupClass("email", form)} >
              <label className="pt-label" htmlFor="email">
                Company Email
              </label>
              <input
                id="email"
                type="email"
                value={form.values.email}
                onChange={form.handleChange}
                placeholder="Company Email"
              />
              {form.touched.email && form.errors.email && (
                <div className="pt-form-helper-text">{form.errors.email}</div>
              )}

            </div>

            <div className={toFormGroupClass("company_size", form)} >
              <label className="pt-label" htmlFor="company_size">
                How big is your company?
              </label>
              <select
                name="company_size"
                value={form.values.company_size}
                onChange={form.handleChange}
                onBlur={form.handleBlur}
              >
                <option value="" label="How big is your company?" >How big is your company?</option>
                <option value="10" label="1-10" >1-10</option>
                <option value="50" label="10-50" >10-50</option>
                <option value="125" label="50-125" >50-125</option>
                <option value="250" label="125-250" >125-250</option>
                <option value="750" label="250-750" >250-750</option>
                <option value="1500" label="750-1500" >750-1500</option>
                <option value="5000" label="1500-5000" >1500-5000</option>
                <option value="10000" label="5000+" >5000+</option>
              </select>
              {form.touched.company_size && form.errors.company_size && (
                <div className="pt-form-helper-text">{form.errors.company_size}</div>
              )}

            </div>


            <div className="pt-form-group">
              <label className="pt-label" htmlFor="note">
                How did you hear about us?
              </label>
              <input
                type="text"
                id="note"
                value={form.values.note}
                onChange={form.handleChange}
                placeholder="How did you hear about us?"
              />
            </div>

            <div className="pt-form-group checkbox">
              <input
                type="checkbox"
                id="c19_roster_access"
                name="roster_access"
                onChange={form.handleChange}
              />
              <label className="pt-label-opt-in" htmlFor="c19_roster_access">
                I have access to my company's current employee roster.
              </label>
            </div>

            <div className="pt-form-group checkbox">
              <input
                type="checkbox"
                id="c19_headcount_access"
                name="headcount_access"
                onChange={form.handleChange}
              />
              <label className="pt-label-opt-in" htmlFor="c19_headcount_access">
                I have access to my company's headcount plans.
              </label>
            </div>

            <button ref={btn => { this.btn = btn; }} type="submit" className="button primary formSubmissionButton">
              REQUEST ACCESS
              </button>

            <p className="opt-in pt-0 pb-0 mb-0">By requesting access, you agree to opt-in to emails from ChartHop.</p>
            {this.state.error && (
              <div
                className="pt-callout pt-intent-danger"
                style={{ marginTop: 10 }}
              >
                <p className="errorTextHeaderForm"><span role="img" aria-label="warning">&#128680;</span>
                Sorry, but we had an unexpected problem submitting your request.
                Try again later, or send a note to{" "}
                <a href="mailto:hello@charthop.com">hello@charthop.com</a>.</p>
              </div>
            )}
          </form>

        )}
      />
    );
  }
}
